import type { PresignedPost } from "../SlideFormat";

/* global FormData fetch Blob */

/**
 * presigned POST で S3 へ実体を直接アップロードする。
 * 認証ヘッダは付与しない（presigned 署名で認可されるため。Bearer/Cookie を足すと署名が壊れる）。
 * `fields` を先に、最後に `file` を append する（S3 presigned POST の仕様順）。
 */
export async function uploadViaPresignedPost(upload: PresignedPost, file: Blob): Promise<void> {
    const form = new FormData();
    for (const [key, value] of Object.entries(upload.fields)) {
        form.append(key, value);
    }
    form.append("file", file);

    const res = await fetch(upload.url, { method: "POST", body: form });
    if (!res.ok) throw new Error(`アップロードに失敗しました (status ${res.status})`);
}
